import { Checkbox, Col, Divider, Form, Row, Typography, InputNumber, Input } from 'antd';
import React from 'react';
import "./style.css";

const { Text } = Typography;

const AdvancedControl = () => {
    return (
        <>
            <div className="section">
                <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>Analysis Settings</Text>
                <Row gutter={[16, 0]} align="middle">
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }} name="analyzeImage" valuePropName="checked"
                            labelCol={{ style: { paddingBottom: 0 } }}>
                            <Checkbox>Image Analysis</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }} name="analyzeVideo" valuePropName="checked"
                            labelCol={{ style: { paddingBottom: 0 } }}>
                            <Checkbox>Video Analysis</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }} name="analyzeAudio" valuePropName="checked"
                            labelCol={{ style: { paddingBottom: 0 } }}>
                            <Checkbox>Audio Analysis</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }} name="analyzeDocument" valuePropName="checked"
                            labelCol={{ style: { paddingBottom: 0 } }}>
                            <Checkbox>Document Analysis</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            
            <Divider style={{ margin: '16px 0' }} />
            
            <div className="section">
                <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>Consumption Settings</Text>
                <Row gutter={[16, 0]} align="middle">
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }} name="is_consumption_limit_enabled" valuePropName="checked" label="Enable Limit"
                            labelCol={{ style: { paddingBottom: 4 } }}>
                            <Checkbox />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }}
                            name="max_coins_consumption"
                            label="Max Coins"
                            labelCol={{ style: { paddingBottom: 4 } }}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                type='number'
                                min={1}
                                disabled={!Form.useWatch('is_consumption_limit_enabled', Form.useFormInstance())}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }}
                            name="consumption_duration"
                            label="Duration (sec)"
                            labelCol={{ style: { paddingBottom: 4 } }}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                type='number'
                                min={1}
                                disabled={!Form.useWatch('is_consumption_limit_enabled', Form.useFormInstance())}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            name="snooze_duration"
                            label="Snooze (sec)"
                            style={{ marginBottom: 0 }}
                            labelCol={{ style: { paddingBottom: 4 } }}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                type='number'
                                min={1}
                                disabled={!Form.useWatch('is_consumption_limit_enabled', Form.useFormInstance())}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            
            <Divider style={{ margin: '16px 0' }} />
            
            <div className="section">
                <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>Processing Settings</Text>
                <Row gutter={[16, 0]} align="middle">
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }}
                            name="is_processing_delay_enabled"
                            valuePropName="checked"
                            label="Enable Delay"
                            labelCol={{ style: { paddingBottom: 4 } }}>
                            <Checkbox />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item style={{ marginBottom: 0 }}
                            name="processing_delay"
                            label="Delay (sec)"
                            labelCol={{ style: { paddingBottom: 4 } }}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                type='number'
                                min={1}
                                max={30}
                                disabled={!Form.useWatch('is_processing_delay_enabled', Form.useFormInstance())}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            style={{ marginBottom: 0 }}
                            name="processing_jitter"
                            label="Jitter (pourcentage)"
                            labelCol={{ style: { paddingBottom: 4 } }}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                type='number'
                                min={1}
                                max={100}
                                disabled={!Form.useWatch('is_processing_delay_enabled', Form.useFormInstance())}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default AdvancedControl;
